import Swiper from 'swiper/bundle';

/**
 * Initializes Swiper instances for elements matching the given selector.
 *
 * @param {string} selector - The CSS selector for the elements to initialize Swiper on.
 * @param {Object} [config={}] - Optional configuration object to customize Swiper settings.
 * @param {number|string} [config.slidesPerView='auto'] - Number of slides per view.
 * @param {number} [config.spaceBetween=30] - Space between slides in pixels.
 * @param {boolean} [config.loop=true] - Enables continuous loop mode.
 * @returns {Swiper[]|null} An array of Swiper instances if elements are found, or null if no elements are found.
 */
export function initializeSwiper(selector, config = {}) {
  const defaultConfig = {
    slidesPerView: 'auto',
    mousewheel: {
      forceToAxis: true,
    },
    spaceBetween: 16,
    loop: true,
    breakpoints: {
      768: {
        spaceBetween: 30
      },
    }
  };

  const swiperConfig = { ...defaultConfig, ...config };

  const swiperElements = document.querySelectorAll(selector);
  const swipers = [];

  if (swiperElements.length === 0) {
    console.warn(`No elements found for selector: ${selector}`);
    return null;
  }

  swiperElements.forEach(element => {
    swipers.push(new Swiper(element, swiperConfig));
  });

  return swipers;
}

/**
 * Initializes Swiper instances for specific lookbook elements.
 *
 * @returns {Object} An object containing arrays of Swiper instances for each lookbook.
 * @property {Swiper[]} swiperLookBook - Swiper instances for elements with the class 'swiper-lookbook'.
 */
export function lookbookSwipers() {
  const swiperLookBook = initializeSwiper('.swiper-lookbook');


  return {
    swiperLookBook,
  };
}
